module.exports = __webpack_public_path__ + "static/media/undercard.098b31d4.jpg";